/**
 * One stable tint per agent for life (spec §20 A13). FNV-1a over the id, reduced to the
 * twenty kin tints. Pure, no crypto import: the web reads it too.
 */
import { KIN_TINTS } from './types.js';

export function kinIndexFor(agentId: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < agentId.length; i++) {
    h ^= agentId.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h % KIN_TINTS;
}
